import type { CallConversation } from "@/playground/components/DevHome/table/graphql/types";
import type { VirtualAgentRow } from "../../../pages/conversation_center/components/Table/Table.decl";

export function getVirtualAgents(
  virtualAgents: CallConversation["virtualAgents"]
): VirtualAgentRow[] {
  return virtualAgents.flatMap((item) => {
    if (item?.virtualAgent?.entity?.__typename !== "VirtualAgent") {
      return [];
    }

    const {
      ID,
      personality: { name },
    } = item.virtualAgent.entity;

    return [{ id: ID, name }];
  });
}
